import { AppRouter } from "@/router";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { useGetUserInfo } from "./hooks/api/useGetUserInfo";
import { NoAuthSubscriber } from "@/components/NoAuthSubscriber";
import { CustomerSupportEntry } from "@/components/profile/CustomerSupportEntry";
import { useUserStore } from "@/store/useUserStore";

export default function App() {
  useVersionCheck();
  const { userInfo } = useUserStore();
  const {} = useGetUserInfo();
  return (
    <>
      <NoAuthSubscriber />
      <AppRouter />
      <CustomerSupportEntry walletAddress={userInfo?.address} />
    </>
  );
}
